import * as React from 'react';

const SvgDownloadCloud = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    stroke="currentColor"
    viewBox="0 0 24 24"
    data-icon="SvgDownloadCloud"
    {...props}
  >
    <path
      d="M20.2 14.925a3.677 3.677 0 00-1.308-5.612A5.551 5.551 0 107.88 7.919a4.158 4.158 0 00-.645-.065 4.234 4.234 0 00-3.094 7.126M12 11.35V21l1.75-1.9 1.75-1.9m-7 0l1.75 1.9L12 21"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export default SvgDownloadCloud;
